import React from 'react'
import LoginForm from '../components/Forms/LoginForm'
import { Box, Typography, Stack } from '@mui/material'
// import { Link } from 'react-router-dom'
import { PublicLink as Link } from '../components/PublicLink'
import { theme } from '../theme'
import Logo from '../icons/primusvest.png'
import { ImageLoader } from '../components/ImageLoader'

const Login = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '40px 0', bgcolor: theme.palette.secondary.main }}>
      <Stack spacing={1}>
       <Link to="/" className="logo">
          <Typography variant='h6' sx={{ display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
              <ImageLoader src={Logo} alt="Logo" style={{ width: '200px' }} loading="eager"/>
          </Typography>
      </Link>
      <LoginForm />
    </Stack>
    </Box>
  )
}

export default Login
